import React from "react";
import classnames from "classnames";

import { ReactComponent as FrameIcon } from "./images/frame.svg";

import styles from "./styles.module.scss";

type PropsType = {
  title: string,
  isActive: boolean,
  isCompleted: boolean
}

export const Step = ({ isActive, title, isCompleted }: PropsType) => {
  return (
    <div className={classnames(styles.root)}>
      <div>
        {
          isCompleted
            ? <div className={classnames(styles.point, styles.pointCompleted)}>
              <FrameIcon />
            </div>
            : <div className={classnames(styles.point, { [styles.pointActive]: isActive })} />
        }
      </div>
      <div className={classnames(styles.title, { [styles.titleActive]: isActive })}>
        {title}
      </div>
    </div>
  );
};

export default Step;
